import { cva } from 'class-variance-authority';
import PropTypes from 'prop-types';

import Entity from '../renders/entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import Icon from '../renders/icon/Icon';

const badgeVariants = cva(
  // eslint-disable-next-line max-len
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        'light-green':
          'bg-badge-light-green-bg border-badge-light-green-border text-badge-light-green-text hover:bg-badge-light-green-bg/80',
        green:
          'bg-badge-green-bg border-badge-green-border text-badge-green-text hover:bg-badge-green-bg/80',
        orange:
          'bg-badge-orange-bg border-badge-orange-border text-badge-orange-text hover:bg-badge-orange-bg/80',
        red:
          'bg-badge-red-bg border-badge-red-border text-badge-red-text hover:bg-badge-red-bg/80',
        blue:
          'bg-badge-blue-bg border-badge-blue-border text-badge-blue-text hover:bg-badge-blue-bg/80',
        gray:
          'bg-badge-gray-bg border-badge-gray-border text-badge-gray-text hover:bg-badge-gray-bg/80'
      }
    },
    defaultVariants: {
      variant: 'gray'
    }
  }
);

/**
 *
 * @param root0
 * @param root0.className
 * @param root0.variant
 * @param root0.entity
 * @param root0.namespace
 * @param root0.icon
 * @param root0.children
 * @returns {JSX} Badge
 */
function Badge({
  className,
  entity,
  namespace,
  variant,
  icon = null,
  children = undefined,
  ...props
}) {
  return (
    <div className={cn(badgeVariants({ variant }), className, icon ? 'cursor-pointer' : '')} {...props}>
      {
        (children ||
          <>
            <Entity entity={entity} namespace={namespace} nowrap />
            {icon && <Icon icon={icon} />}
          </>)
      }
    </div>
  );
}

Badge.propTypes = {
  className: PropTypes.string,
  entity: PropTypes.string,
  namespace: PropTypes.string,
  variant: PropTypes.oneOf(
    ['light-green', 'green', 'orange', 'red', 'blue', 'gray']
  ),
  icon: PropTypes.string,
  children: PropTypes.node
};

export { Badge, badgeVariants };
